import { heroImage } from '../data/copy'
import {
  HERO_SIZES,
  HERO_WIDTHS,
  optimizedImage,
  optimizedSrcSet,
} from './image'

const TITLE = 'PALLAMANO 360™ - Il Sistema Visuale per Allenatori di Pallamano'
const DESCRIPTION =
  'Il sistema digitale visuale per allenatori di pallamano: 6 volumi tecnici, 72 sessioni da 60 minuti e 5 bonus operativi. Pianifica il tuo allenamento in 5 minuti.'

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  )
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.content = content
}

function appendLink(attrs: Record<string, string>): HTMLLinkElement {
  const link = document.createElement('link')
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
  return link
}

/**
 * Prepara el <head> antes del primer render:
 *
 * - idioma, título y metadatos sociales (SEO / compartir);
 * - precarga de la imagen del hero, que es el elemento LCP.
 *
 * La tipografía (Oswald + Inter) va self-hosted vía @fontsource (index.tsx),
 * sin peticiones bloqueantes a Google Fonts.
 */
export function setupHead(): void {
  if (typeof document === 'undefined') return

  document.documentElement.lang = 'it'
  document.title = TITLE

  upsertMeta('name', 'description', DESCRIPTION)
  // paper, el fondo de la página
  upsertMeta('name', 'theme-color', '#F3ECDF')
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:title', TITLE)
  upsertMeta('property', 'og:description', DESCRIPTION)
  upsertMeta('property', 'og:image', heroImage)
  upsertMeta('name', 'twitter:card', 'summary_large_image')
  upsertMeta('name', 'twitter:title', TITLE)
  upsertMeta('name', 'twitter:description', DESCRIPTION)
  upsertMeta('name', 'twitter:image', heroImage)

  if (document.head.querySelector('link[data-mp-head]')) return

  // Conexión anticipada al proxy de imágenes: ahorra DNS + TLS antes del LCP.
  appendLink({
    rel: 'preconnect',
    href: 'https://wsrv.nl',
    'data-mp-head': 'cdn',
  })

  // La imagen del hero es el LCP: se precarga en el mismo tamaño responsive
  // que usará el <img>, antes de que React monte.
  appendLink({
    rel: 'preload',
    as: 'image',
    href: optimizedImage(heroImage, 960),
    imagesrcset: optimizedSrcSet(heroImage, HERO_WIDTHS),
    imagesizes: HERO_SIZES,
    fetchpriority: 'high',
    'data-mp-head': 'hero',
  })
}
